var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.46438C0 1.99875 1.99875 0 4.46438 0C5.63437 0 6.70312 0.451781 7.5 1.19062L0.696562 6.8625C0.255562 6.16875 0 5.34844 0 4.46438ZM18.2906 21.9094C16.5375 23.2219 14.3578 24 12 24C9.64219 24 7.4625 23.2219 5.71406 21.9094L4.06078 23.5594C3.47484 24.1453 2.52516 24.1453 1.93922 23.5594C1.35375 22.9734 1.35375 22.0266 1.93922 21.4406L3.59062 19.7906C2.27766 18.0375 1.5 15.8578 1.5 13.5C1.5 7.70156 6.20156 3 12 3C17.7984 3 22.5 7.70156 22.5 13.5C22.5 15.8578 21.7219 18.0375 20.4094 19.7906L22.0594 21.4406C22.6453 22.0266 22.6453 22.9734 22.0594 23.5594C21.4734 24.1453 20.5266 24.1453 19.9406 23.5594L18.2906 21.9094ZM10.875 9.375V12.375H7.875C7.25156 12.375 6.75 12.8766 6.75 13.5C6.75 14.1234 7.25156 14.625 7.875 14.625H10.875V17.625C10.875 18.2484 11.3766 18.75 12 18.75C12.6234 18.75 13.125 18.2484 13.125 17.625V14.625H16.125C16.7484 14.625 17.25 14.1234 17.25 13.5C17.25 12.8766 16.7484 12.375 16.125 12.375H13.125V9.375C13.125 8.75156 12.6234 8.25 12 8.25C11.3766 8.25 10.875 8.75156 10.875 9.375ZM19.5375 0C22.0031 0 24 1.99875 24 4.46438C24 5.34375 23.7422 6.16875 23.3016 6.8625L16.5 1.19062C17.2547 0.451781 18.3656 0 19.5375 0Z",
    fill: "#8A0538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockHomeIcon);
export default __webpack_public_path__ + "static/media/ClockHomeIcon.a0782a05b3be5c02d34e53a19e356bf6.svg";
export { ForwardRef as ReactComponent };